// import {mapState, mapMutations} from 'vuex'

export default {
  computed: {
    challengeMode () {
      return this.$route.name === 'Challenge'
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/challenge.js